document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('SizeGuideModal');
  if (!modal) return;

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-sizeguide]')) {
      e.preventDefault();
      openModal();
    }
    if (e.target.closest('[data-sizeguide-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
});